import React from 'react'
import styles from './index.module.scss'
import { Check } from '../../../../../assets/NewDashboard'

const GeneralTable = ({ general }) => {
  return (
    <div className={styles.generalSection}>
      <table className={styles.generalTable}>
        <thead>
          <tr>
            <th>Краткая сводка по специальности</th>
            <th>Требования ФГОС</th>
            <th>РУП</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Формы получения образования</td>
            <td>{general?.edu_form_fgos || '-'}</td>
            <td>{general?.edu_form || '-'}</td>
          </tr>
          <tr>
            <td>Объем программы</td>
            <td>{general?.scope_programm_fgos ? `${general.scope_programm_fgos} з.е.` : '-'}</td>
            
            <td className={general?.scope_programm_check === false ? styles.errorCell : ''}>
              {general?.scope_programm ? `${general.scope_programm} з.е.` : '-'}
              {general?.scope_programm_check === false && <Check mode="notComplete" />}
            </td>
          </tr>
          <tr>
            <td>Объем программы за один год вне зависимости от формы обучения, применяемых образовательных технологий</td>
            <td>-</td>
            <td> -
              {/* <span className={styles.checkBlock_}>73 з.е.
                <Check mode="notComplete" className={styles.notComplete} />
              </span> */}
            </td>
          </tr>
          <tr>
            <td>Срок получения образования</td>
            <td>{general?.period_education_fgos ? `${general.period_education_fgos} (лет)` : '-'}</td>
            <td className={general?.period_education_check === false ? styles.errorCell : ''}>
              {general?.period_education ? `${general.period_education} (лет)` : '-'}
              {general?.period_education_check === false && <Check mode="notComplete" />}
            </td>
          </tr>
          <tr>
            <td>Объем программы за один год</td>
            <td>-</td>
            <td>-
              {/* <span className={styles.checkBlock_}>73 з.е.
                <Check mode="notComplete" className={styles.notComplete} />
              </span> */}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default GeneralTable
